import { createSlice } from '@reduxjs/toolkit';

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState: {
    value: []
  },
  reducers: {
    setFeatureFlags: (state, action) => {
      state.value = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setFeatureFlags } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
